import React from 'react';
import {Backdrop, createStyles, Theme} from "@material-ui/core";
import makeStyles from '@material-ui/core/styles/makeStyles';
import "./index.scss";
import plus from "../../images/plus.svg";
import minus from "../../images/minus.svg";
import {strings} from "../../strings/strings";
import {ProductType} from "../../api/model/common";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        backdrop: {
            zIndex: theme.zIndex.drawer + 1
        }
    })
);

interface QuestionsPopupProps {
    isOpen: boolean
    onClose: () => void
    type: ProductType
}

export const QuestionsPopup = ({isOpen, onClose, type}: QuestionsPopupProps) => {
    const classes = useStyles();

    const onAccordionClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        let classList = event.currentTarget.classList;

        if (classList.contains("open")) {
            classList.remove("open");
        } else {
            classList.add("open");
        }
    };

    return (
        <div>
            <Backdrop open={isOpen} className={classes.backdrop}>
                <div className={"questions-popup"}>
                    <button className="close" onClick={onClose} aria-label="Close"/>

                    <div className="faq">
                        {
                            type === ProductType.TRAVEL ?
                                <div className="container"><h2>{strings.questionsPopupTravel.title}</h2>
                                    <div className="accordion-wr">
                                        
                                        <div className="accordion" onClick={onAccordionClick}>
                                            <button type="button" className="accordion-btn">
                                    <span className="icon">
                                        <img src={plus} alt="+"/>
                                        <img src={minus} alt="-"/>
                                    </span>
                                                <span className="name">{strings.questionsPopupTravel.text40}</span>
                                            </button>
                                            <div className="text"><p>{strings.questionsPopupTravel.text41}</p></div>
                                        </div>
                                        <div className="accordion" onClick={onAccordionClick}>
                                            <button type="button" className="accordion-btn">
                                    <span className="icon">
                                        <img src={plus} alt="+"/>
                                        <img src={minus} alt="-"/>
                                    </span>
                                                <span className="name">{strings.questionsPopupTravel.text42}</span>
                                            </button>
                                            <div className="text"><p>{strings.questionsPopupTravel.text43}</p></div>
                                        </div>
                                        <div className="accordion" onClick={onAccordionClick}>
                                            <button type="button" className="accordion-btn">
                                    <span className="icon">
                                        <img src={plus} alt="+"/>
                                        <img src={minus} alt="-"/>
                                    </span>
                                                <span className="name">{strings.questionsPopupTravel.text44}</span>
                                            </button>
                                            <div className="text"><p>{strings.questionsPopupTravel.text45}</p></div>
                                        </div>
                                        <div className="accordion" onClick={onAccordionClick}>
                                            <button type="button" className="accordion-btn">
                                    <span className="icon">
                                        <img src={plus} alt="+"/>
                                        <img src={minus} alt="-"/>
                                    </span>
                                                <span className="name">{strings.questionsPopupTravel.text46}</span>
                                            </button>
                                            <div className="text"><p>{strings.questionsPopupTravel.text47}</p></div>
                                        </div>
                                        <div className="accordion" onClick={onAccordionClick}>
                                            <button type="button" className="accordion-btn">
                                    <span className="icon">
                                        <img src={plus} alt="+"/>
                                        <img src={minus} alt="-"/>
                                    </span>
                                                <span className="name">{strings.questionsPopupTravel.text48}</span>
                                            </button>
                                            <div className="text"><p>{strings.questionsPopupTravel.text49}</p></div>
                                        </div>
                                        <div className="accordion" onClick={onAccordionClick}>
                                            <button type="button" className="accordion-btn">
                                    <span className="icon">
                                        <img src={plus} alt="+"/>
                                        <img src={minus} alt="-"/>
                                    </span>
                                                <span className="name">{strings.questionsPopupTravel.text50}</span>
                                            </button>
                                            <div className="text"><p>{strings.questionsPopupTravel.text51}</p></div>
                                        </div>
                                        <div className="accordion" onClick={onAccordionClick}>
                                            <button type="button" className="accordion-btn">
                                    <span className="icon">
                                        <img src={plus} alt="+"/>
                                        <img src={minus} alt="-"/>
                                    </span>
                                                <span className="name">{strings.questionsPopupTravel.text52}</span>
                                            </button>
                                            <div className="text"><p>{strings.questionsPopupTravel.text53}</p></div>
                                        </div>
                                        <div className="accordion" onClick={onAccordionClick}>
                                            <button type="button" className="accordion-btn">
                                    <span className="icon">
                                        <img src={plus} alt="+"/>
                                        <img src={minus} alt="-"/>
                                    </span>
                                                <span className="name">{strings.questionsPopupTravel.text54}</span></button>
                                            <div className="text"><p>{strings.questionsPopupTravel.text55}</p>
                                                <ol>
                                                    <li>{strings.questionsPopupTravel.text56}</li>
                                                    <li>{strings.questionsPopupTravel.text57}</li>
                                                    <li>{strings.questionsPopupTravel.text58}</li>
                                                    <li>{strings.questionsPopupTravel.text59}</li>
                                                    <li>{strings.questionsPopupTravel.text60}</li>
                                                    <li>{strings.questionsPopupTravel.text61}</li>
                                                    <li>{strings.questionsPopupTravel.text62}</li>
                                                    <li>{strings.questionsPopupTravel.text63}</li>
                                                    <li>{strings.questionsPopupTravel.text64}</li>
                                                    <li>{strings.questionsPopupTravel.text65}</li>
                                                    <li>{strings.questionsPopupTravel.text66}</li>
                                                    <li>{strings.questionsPopupTravel.text67}</li>
                                                </ol>
                                                <p>{strings.questionsPopupTravel.text68}</p></div>
                                        </div>
                                        <div className="accordion" onClick={onAccordionClick}>
                                            <button type="button" className="accordion-btn">
                                    <span className="icon">
                                        <img src={plus} alt="+"/>
                                        <img src={minus} alt="-"/>
                                    </span>
                                                <span className="name">{strings.questionsPopupTravel.text69}</span></button>
                                            <div className="text"><p>{strings.questionsPopupTravel.text70}</p>
                                                <ol>
                                                    <li>{strings.questionsPopupTravel.text71}</li>
                                                    <li>{strings.questionsPopupTravel.text72}</li>
                                                    <li>{strings.questionsPopupTravel.text73}</li>
                                                    <li>{strings.questionsPopupTravel.text74}</li>
                                                    <li>{strings.questionsPopupTravel.text75}</li>
                                                    <li>{strings.questionsPopupTravel.text76}</li>
                                                    <li>{strings.questionsPopupTravel.text77}</li>
                                                    <li>{strings.questionsPopupTravel.text78}</li>
                                                    <li>{strings.questionsPopupTravel.text79}</li>
                                                </ol>
                                                <p>{strings.questionsPopupTravel.text80}</p></div>
                                        </div>
                                        <div className="accordion" onClick={onAccordionClick}>
                                            <button type="button" className="accordion-btn">
                                    <span className="icon">
                                        <img src={plus} alt="+"/>
                                        <img src={minus} alt="-"/>
                                    </span>
                                                <span className="name">{strings.questionsPopupTravel.text81}</span></button>
                                            <div className="text"><p>{strings.questionsPopupTravel.text82}</p></div>
                                        </div>
                                    </div>
                                </div>
                                :
                                type === ProductType.EMTPL
                                ?   <div className="container">
                                        <h2>{strings.questionsPopup.title}</h2>
                                        <div className="accordion-wr">
                                        <div className="accordion" onClick={onAccordionClick}>
                                            <button type="button" className="accordion-btn">
                                    <span className="icon">
                                        <img src={plus} alt="+"/>
                                        <img src={minus} alt="-"/>
                                    </span>
                                                <span
                                                    className="name">{strings.questionsPopup.text1}</span>
                                            </button>
                                            <div className="text"><p>{strings.questionsPopup.text2}</p></div>
                                        </div>
                                        <div className="accordion" onClick={onAccordionClick}>
                                            <button type="button" className="accordion-btn">
                                    <span className="icon">
                                        <img src={plus} alt="+"/>
                                        <img src={minus} alt="-"/>
                                    </span>
                                                <span className="name">{strings.questionsPopup.text3}</span>
                                            </button>
                                            <div className="text"><p>{strings.questionsPopup.text4}</p></div>
                                        </div>
                                        <div className="accordion" onClick={onAccordionClick}>
                                            <button type="button" className="accordion-btn">
                                    <span className="icon">
                                        <img src={plus} alt="+"/>
                                        <img src={minus} alt="-"/>
                                    </span>
                                                <span className="name">{strings.questionsPopup.text5}</span>
                                            </button>
                                            <div className="text"><p>{strings.questionsPopup.text6}</p></div>
                                        </div>
                                        <div className="accordion" onClick={onAccordionClick}>
                                            <button type="button" className="accordion-btn">
                                    <span className="icon">
                                        <img src={plus} alt="+"/>
                                        <img src={minus} alt="-"/>
                                    </span>
                                                <span
                                                    className="name">{strings.questionsPopup.text7}</span>
                                            </button>
                                            <div className="text"><p>{strings.questionsPopup.text8}&nbsp;<a
                                                href={strings.refs.mtsbu}
                                                target="_blank"
                                                rel="noopener noreferrer">{strings.questionsPopup.text9}</a>.</p>
                                            </div>
                                        </div>
                                        <div className="accordion" onClick={onAccordionClick}>
                                            <button type="button" className="accordion-btn">
                                    <span className="icon">
                                        <img src={plus} alt="+"/>
                                        <img src={minus} alt="-"/>
                                    </span>
                                                <span className="name">{strings.questionsPopup.text10}</span>
                                            </button>
                                            <div className="text"><p>{strings.questionsPopup.text11}</p></div>
                                        </div>
                                        <div className="accordion" onClick={onAccordionClick}>
                                            <button type="button" className="accordion-btn">
                                    <span className="icon">
                                        <img src={plus} alt="+"/>
                                        <img src={minus} alt="-"/>
                                    </span>
                                                <span className="name">{strings.questionsPopup.text12}</span>
                                            </button>
                                            <div className="text"><p>{strings.questionsPopup.text13}</p></div>
                                        </div>
                                        <div className="accordion" onClick={onAccordionClick}>
                                            <button type="button" className="accordion-btn">
                                    <span className="icon">
                                        <img src={plus} alt="+"/>
                                        <img src={minus} alt="-"/>
                                    </span>
                                                <span className="name">{strings.questionsPopup.text14}</span>
                                            </button>
                                            <div className="text"><p>
                                                <strong>{strings.questionsPopup.text15}</strong>{strings.questionsPopup.text16}
                                            </p><p>
                                                <strong>{strings.questionsPopup.text17}</strong>{strings.questionsPopup.text18}
                                            </p></div>
                                        </div>
                                        <div className="accordion" onClick={onAccordionClick}>
                                            <button type="button" className="accordion-btn">
                                    <span className="icon">
                                        <img src={plus} alt="+"/>
                                        <img src={minus} alt="-"/>
                                    </span>
                                                <span
                                                    className="name">{strings.questionsPopup.text19}</span>
                                            </button>
                                            <div className="text"><p>{strings.questionsPopup.text20}</p></div>
                                        </div>
                                        <div className="accordion" onClick={onAccordionClick}>
                                            <button type="button" className="accordion-btn">
                                    <span className="icon">
                                        <img src={plus} alt="+"/>
                                        <img src={minus} alt="-"/>
                                    </span>
                                                <span className="name">{strings.questionsPopup.text21}</span>
                                            </button>
                                            <div className="text"><p>{strings.questionsPopup.text22}&nbsp;</p></div>
                                        </div>
                                        <div className="accordion" onClick={onAccordionClick}>
                                            <button type="button" className="accordion-btn">
                                    <span className="icon">
                                        <img src={plus} alt="+"/>
                                        <img src={minus} alt="-"/>
                                    </span>
                                                <span className="name">{strings.questionsPopup.text23}</span>
                                            </button>
                                            <div className="text"><p>{strings.questionsPopup.text24}</p></div>
                                        </div>
                                        <div className="accordion" onClick={onAccordionClick}>
                                            <button type="button" className="accordion-btn">
                                    <span className="icon">
                                        <img src={plus} alt="+"/>
                                        <img src={minus} alt="-"/>
                                    </span>
                                                <span className="name">{strings.questionsPopup.text25}</span></button>
                                            <div className="text"><p>{strings.questionsPopup.text26}</p>
                                                <ol>
                                                    <li>{strings.questionsPopup.text27}</li>
                                                    <li>{strings.questionsPopup.text28}</li>
                                                    <li>{strings.questionsPopup.text29}</li>
                                                    <li>{strings.questionsPopup.text30}</li>
                                                    <li>{strings.questionsPopup.text31}</li>
                                                    <li>{strings.questionsPopup.text32}</li>
                                                    <li>{strings.questionsPopup.text33}</li>
                                                    <li>{strings.questionsPopup.text34}</li>
                                                </ol>
                                                <p>{strings.questionsPopup.text35}</p></div>
                                        </div>
                                        <div className="accordion" onClick={onAccordionClick}>
                                            <button type="button" className="accordion-btn">
                                    <span className="icon">
                                        <img src={plus} alt="+"/>
                                        <img src={minus} alt="-"/>
                                    </span>
                                                <span className="name">{strings.questionsPopup.text36}</span>
                                            </button>
                                            <div className="text"><p>{strings.questionsPopup.text37}</p></div>
                                        </div>
                                        <div className="accordion" onClick={onAccordionClick}>
                                            <button type="button" className="accordion-btn">
                                                <span className="icon">
                                                    <img src={plus} alt="+"/>
                                                    <img src={minus} alt="-"/>
                                                </span>
                                                <span className="name">{strings.questionsPopup.text38}</span>
                                            </button>
                                            <div className="text">
                                                <p>{strings.questionsPopup.text39}</p>
                                            </div>
                                        </div>
                                    </div>
                                    </div>
                                :
                                <div className="container"><h2>{strings.questionsPopup.title}</h2>
                                    <div className="accordion-wr">
                                        <div className="accordion" onClick={onAccordionClick}>
                                            <button type="button" className="accordion-btn">
                                                <span className="icon">
                                                    <img src={plus} alt="+"/>
                                                    <img src={minus} alt="-"/>
                                                </span>
                                                <span className="name">{strings.questionsPopup.text40}</span>
                                            </button>
                                            <div className="text">
                                                <p>{strings.questionsPopup.text41} <a href="https://arx.com.ua/uploads/Zrazok_polisa_Zelena_kartka_dlia_Yevropy_ta_inshykh_krain.pdf" target="_blank">{strings.questionsPopup.text42}</a> {strings.questionsPopup.text43}</p>
                                            </div>
                                        </div>
                                        <div className="accordion" onClick={onAccordionClick}>
                                            <button type="button" className="accordion-btn">
                                                <span className="icon">
                                                    <img src={plus} alt="+"/>
                                                    <img src={minus} alt="-"/>
                                                </span>
                                                <span className="name">{strings.questionsPopup.text44}</span>
                                            </button>
                                            <div className="text">
                                                <p>{strings.questionsPopup.text45}</p>
                                            </div>
                                        </div>
                                        <div className="accordion" onClick={onAccordionClick}>
                                            <button type="button" className="accordion-btn">
                                                <span className="icon">
                                                    <img src={plus} alt="+"/>
                                                    <img src={minus} alt="-"/>
                                                </span>
                                                <span className="name">{strings.questionsPopup.text46}</span>
                                            </button>
                                            <div className="text">
                                                <p>{strings.questionsPopup.text47}</p>
                                            </div>
                                        </div>
                                        <div className="accordion" onClick={onAccordionClick}>
                                            <button type="button" className="accordion-btn">
                                                <span className="icon">
                                                    <img src={plus} alt="+"/>
                                                    <img src={minus} alt="-"/>
                                                </span>
                                                <span className="name">{strings.questionsPopup.text48}</span>
                                            </button>
                                            <div className="text">
                                                <p>{strings.questionsPopup.text49}</p>
                                            </div>
                                        </div>
                                        <div className="accordion" onClick={onAccordionClick}>
                                            <button type="button" className="accordion-btn">
                                                <span className="icon">
                                                    <img src={plus} alt="+"/>
                                                    <img src={minus} alt="-"/>
                                                </span>
                                                <span className="name">{strings.questionsPopup.text50}</span>
                                            </button>
                                            <div className="text">
                                                <p>{strings.questionsPopup.text51}</p>
                                            </div>
                                        </div>
                                        <div className="accordion" onClick={onAccordionClick}>
                                            <button type="button" className="accordion-btn">
                                                <span className="icon">
                                                    <img src={plus} alt="+"/>
                                                    <img src={minus} alt="-"/>
                                                </span>
                                                <span className="name">{strings.questionsPopup.text52}</span>
                                            </button>
                                            <div className="text">
                                                <p>{strings.questionsPopup.text53}</p>
                                            </div>
                                        </div>
                                        <div className="accordion" onClick={onAccordionClick}>
                                            <button type="button" className="accordion-btn">
                                                <span className="icon">
                                                    <img src={plus} alt="+"/>
                                                    <img src={minus} alt="-"/>
                                                </span>
                                                <span className="name">{strings.questionsPopup.text54}</span>
                                            </button>
                                            <div className="text">
                                                <p>{strings.questionsPopup.text55}</p>
                                                <ul>
                                                    <li>{strings.questionsPopup.text56}</li>
                                                    <li>{strings.questionsPopup.text57}</li>
                                                    <li>{strings.questionsPopup.text58}</li>
                                                    <li>{strings.questionsPopup.text59}</li>
                                                    <li>{strings.questionsPopup.text60}</li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="accordion" onClick={onAccordionClick}>
                                            <button type="button" className="accordion-btn">
                                                <span className="icon">
                                                    <img src={plus} alt="+"/>
                                                    <img src={minus} alt="-"/>
                                                </span>
                                                <span className="name">{strings.questionsPopup.text61}</span>
                                            </button>
                                            <div className="text">
                                                <p>{strings.questionsPopup.text62}</p>
                                            </div>
                                        </div>
                                        <div className="accordion" onClick={onAccordionClick}>
                                            <button type="button" className="accordion-btn">
                                                <span className="icon">
                                                    <img src={plus} alt="+"/>
                                                    <img src={minus} alt="-"/>
                                                </span>
                                                <span className="name">{strings.questionsPopup.text63}</span>
                                            </button>
                                            <div className="text">
                                                <p>{strings.questionsPopup.text64}</p>
                                            </div>
                                        </div>
                                        <div className="accordion" onClick={onAccordionClick}>
                                            <button type="button" className="accordion-btn">
                                                <span className="icon">
                                                    <img src={plus} alt="+"/>
                                                    <img src={minus} alt="-"/>
                                                </span>
                                                <span className="name">{strings.questionsPopup.text65}</span>
                                            </button>
                                            <div className="text">
                                                <p>{strings.questionsPopup.text66}</p>
                                            </div>
                                        </div>
                                        <div className="accordion" onClick={onAccordionClick}>
                                            <button type="button" className="accordion-btn">
                                                <span className="icon">
                                                    <img src={plus} alt="+"/>
                                                    <img src={minus} alt="-"/>
                                                </span>
                                                <span className="name">{strings.questionsPopup.text67}</span>
                                            </button>
                                            <div className="text">
                                                <p>{strings.questionsPopup.text68}</p>
                                            </div>
                                        </div>
                                        <div className="accordion" onClick={onAccordionClick}>
                                            <button type="button" className="accordion-btn">
                                                <span className="icon">
                                                    <img src={plus} alt="+"/>
                                                    <img src={minus} alt="-"/>
                                                </span>
                                                <span className="name">{strings.questionsPopup.text69}</span>
                                            </button>
                                            <div className="text">
                                                <p>{strings.questionsPopup.text70}</p>
                                            </div>
                                        </div>
                                        <div className="accordion" onClick={onAccordionClick}>
                                            <button type="button" className="accordion-btn">
                                                <span className="icon">
                                                    <img src={plus} alt="+"/>
                                                    <img src={minus} alt="-"/>
                                                </span>
                                                <span className="name">{strings.questionsPopup.text71}</span>
                                            </button>
                                            <div className="text">
                                                <p>{strings.questionsPopup.text72}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                        }
                    </div>
                </div>
            </Backdrop>
        </div>
    )
};